import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {GameBox} from "./boxes/game.box";
import {GameInfo, OpenGameParameters} from "../../services/games/game-info";
import {GameDetailsBox} from "./boxes/game-details.box";
import {GameDividerBox} from "./boxes/game-divider.box";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {ButtonWrapperBox} from "../balance-box/balance-box-buttons/boxes/button-wrapper.box";
import {GameImageBox} from "./boxes/game-image.box";
import {GameDetailsNameBox} from "./boxes/game-details-name.box";
import {GameImageComponent} from "../single-game/common/parts/game-image/game-image.component";
import {observer} from "mobx-react";
import {GameDetailsJpBox} from "./boxes/game-details-jp.box";
import classNames from "classnames";
import {NO_JACKPOT} from "./css-classes";

export interface VerticalGamesListGameComponentProps{
  gameInfo: GameInfo;
  onGameOpen():void;
  seoCategory: string;
  listTitle: string;
  gameIndex: number;
  displayJackpotInfo: boolean;
}

export const VerticalGamesListGameComponent = observer(
  class VerticalGamesListGameComponent extends OrbitComponent<VerticalGamesListGameComponentProps> {

    private _openGame(){
      this.props.onGameOpen();

      this.services.analytics.sendAnalytics(this.props.seoCategory, this.props.listTitle, this.props.gameInfo.gameType.toString());

      const openGameParams: OpenGameParameters = {
        isRealMode: true,
        pageName: "Drawer",
        listTitle: this.props.listTitle,
        gameIndex: this.props.gameIndex,
        openFromDrawer: true
      };

      this.props.gameInfo.open(openGameParams);
    }

    private _renderJackpot(){
      if(this.hasJackpot){
        return (
            <GameDetailsJpBox gameType={this.props.gameInfo.gameType}/>
        )
      } else {
        return null;
      }
    }

    private get hasJackpot(): boolean
    {
      return (this.props.displayJackpotInfo && this.props.gameInfo.hasJackpot);
    }

    render(){
      return(
        <GameBox className='cy-vertical-list-game'>
          <GameImageBox>
            <GameImageComponent gameInfo={this.props.gameInfo} useLazyLoading={false}/>
          </GameImageBox>
          <GameDividerBox/>
          <GameDetailsBox>
            <GameDetailsNameBox className={classNames('cy-vertical-list-game-name', {[NO_JACKPOT]: !this.hasJackpot})}>{this.props.gameInfo.title}</GameDetailsNameBox>
            {this._renderJackpot()}
            <ButtonWrapperBox>
              <Button className="cy-play-jackpot-game" fullWidth sizeVariant="small" preset="primaryInverted" onClick={() => {this._openGame()}}>
                {this.services.translation.translate('PLAY')}
              </Button>
            </ButtonWrapperBox>
          </GameDetailsBox>
        </GameBox>)
    }
  }
);